export function validatePassword(password: string): boolean {
  if (!password) {
    return false;
  }
  // 영문 숫자 특수기호 조합 8자리 이상 15자리 이하
  return /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/.test(password);
}
